import {defineStore} from 'pinia'
import {useApiRequestStore} from '../../ApiRequestStore/useApiRequestStore'
import {LocaleType} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/enum/LocaleType'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {SystemMessagePriorityType} from '@toolify/server/src/enum/SystemMessagePriorityType'

export interface ISystemMessageDto {
  id: string
  content: string
  localeType: LocaleType
  priority: SystemMessagePriorityType
  iconNameType?: IconNameType
  publishedAt: string | Date | null
  expiresAt: string | Date | null
  createdAt: string | Date
}

export const useSystemMessageApiStore = defineStore('systemMessageApi', {
  actions: {
    async getCurrent(): Promise<{systemMessages: ISystemMessageDto[]}> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.get('/system-messages') as unknown as {systemMessages: ISystemMessageDto[]}
    },

    async acknowledgeMany(systemMessageIds: string[]): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.post('/system-messages/acknowledge', {data: {systemMessageIds}})
    },
  },
})

